import React, { PureComponent, Fragment } from 'react';
import { CopyOutlined, SelectOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Tooltip, Modal, Row, Col, Button, message } from 'antd';
import { Link } from 'umi';
import styles from '../style.less'

class CreateRole extends PureComponent {

    copyId(params) {
        try {
            const { accountId, externalId } = this.props
            if (params === 'accId') {
                navigator.clipboard.writeText(accountId);
                message.success(`Account Id copied`);
            }
            if (params === 'extId') {
                navigator.clipboard.writeText(externalId);
                message.success(`External Id copied`);
            }
        } catch (err) {
            //
            //   message.error(`Something went wrong with copying`);
        }
    }

    render() {
        const { accountId, externalId } = this.props
        return (
          <div className={styles.awsForm}>
            <Row>
              <Col span={20}>
                <p style={{ fontWeight: 600, fontSize: '13px' }}>Create a new role</p>
                <p style={{ fontSize: '12px' }}>By clicking on the button below, you will be directed to your AWS console.<br />
                 Select "Another AWS Account" as trusted entity type and paste the ID.
                </p>
                <div style={{ display: 'inline-flex' }}>
                  <span style={{ fontSize: '13px' }}>AWS Account ID <p style={{ fontSize: '14px', fontWeight: 600 }}>{accountId}<CopyOutlined
                    onClick={e => { this.copyId('accId') }}
                    style={{ marginLeft: '10px', cursor: 'pointer', color: '#0090ff' }}
                  />
                  </p>
                  </span>
                  <span style={{ fontSize: '13px', marginLeft: '83px' }}>External ID <p style={{ fontSize: '14px', fontWeight: 600 }}>{externalId}<CopyOutlined
                    onClick={e => { this.copyId('extId') }}
                    style={{ marginLeft: '10px', cursor: 'pointer', color: '#0090ff' }}
                  />
                  </p>
                  </span>

                </div>
              </Col>
              <Col span={4} style={{ float: 'right' }}>
                <a
                  href="https://signin.aws.amazon.com/signin?redirect_uri=https%3A%2F%2Fconsole.aws.amazon.com%2Fconsole%2Fhome%3Fstate%3DhashArgs%2523%26isauthcode%3Dtrue&client_id=arn%3Aaws%3Aiam%3A%3A015428540659%3Auser%2Fhomepage&forceMobileApp=0&code_challenge=kV_TrRdicPPds8Rs4dfYjucRqYskItnXbOmIYPxdpns&code_challenge_method=SHA-256"
                  target="_blank"
                >                            <Button icon={<SelectOutlined />} style={{ maxHeight: '25px', fontSize: '10px' }} type='primary'>Open AWS</Button>
                </a>
              </Col>
            </Row>
          </div>
        );
    }
}

export default CreateRole;
